import { useLazyQuery, useMutation } from "@apollo/client/react"; import React, { useEffect, useState } from 'react';
import { Card, CardContent, Grid } from '@mui/material';
import toast, { Toaster } from 'react-hot-toast';

import { RadioGroupInput } from '../../../components/radioGroupInput/RadioGroupInput';
import { GET_ALL_TIPO_PROFESIONAL_ESPECIALIDAD } from '../../../data/graphQL/queries/PlanCuidado/getTipoProfesionalEspecialidad';
import { GET_ALL_TIPO_PROFESIONALES } from '../../../data/graphQL/queries/PlanCuidado/getTipoProfesionales';
import { adaptTipoProfesionalArray } from '../../../adapters/tipoProfesionalAdapter';
import { adaptAllTipoProfesionalEspecialidadArray } from '../../../adapters/allTipoProfesionalEspecialidadAdapter';
import { CREATE_PROFESIONAL_EVALUACION } from '../../../data/graphQL/mutations/ResumenIngresoValidation/CreateProfesionalEvaluacion';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { adaptProfesionalesContrato, adaptProfesionalesIdsContrato, GET_PROFESIONALES_CONTRATO } from '../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getProfesionalesContrato';
import './profesionales.scss';

export const ProfesionalesInput = ({
  idEvaluacion,
  readOnly,
  moduloCP
}) => {
  const [profesionales, setProfesionales] = useState({
    profesionalTipos: [],
    profesionalEspecialidades: []
  });
  const [profesionalesEspecialidad, setTipoProfesionalesEspecialidad] = useState();
  const [tiposProfesionales, setTipoProfesionales] = useState();

  const [getTipoProfesionales, { data: tipoProfesionalesData, loading: tipoProfesionalesLoading }] = useLazyQuery(GET_ALL_TIPO_PROFESIONALES, {
    fetchPolicy: 'no-cache',
  });

  const [getTipoProfesionalesEspecialidad, { data: tipoProfesionalesEspecialidadData, loading: tipoProfesionalEspecialidadLoading }] = useLazyQuery(GET_ALL_TIPO_PROFESIONAL_ESPECIALIDAD, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!tipoProfesionalesData) return;

    setTipoProfesionales(adaptTipoProfesionalArray(tipoProfesionalesData));
  }, [tipoProfesionalesData]);

  useEffect(() => {
    if (!tipoProfesionalesEspecialidadData) return;

    setTipoProfesionalesEspecialidad(adaptAllTipoProfesionalEspecialidadArray(tipoProfesionalesEspecialidadData));
  }, [tipoProfesionalesEspecialidadData]);

  useEffect(() => {
    if (!tipoProfesionalesLoading) {
      getTipoProfesionales();
    }
    if (!tipoProfesionalEspecialidadLoading) {
      getTipoProfesionalesEspecialidad();
    }
  }, []);

  const [getProfesionales] = useLazyQuery(GET_PROFESIONALES_CONTRATO, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!idEvaluacion) return;
    getProfesionales({variables: { idEvaluacion }}).
      then((res) => {
        const { profesionalRI } = adaptProfesionalesIdsContrato(res?.data);

        handleChange('profesionalTipos', profesionalRI?.profesionalRI);
        handleChange('profesionalEspecialidades', profesionalRI?.profesionalEspecialidadRI);
      });
  }, [idEvaluacion]);

  const [createProfesionales, { loading: profesionalesLoading }] = useMutation(CREATE_PROFESIONAL_EVALUACION, {
    fetchPolicy: 'no-cache'
  });

  const onSubmit = async () => {
    try {
      await createProfesionales({
        variables: {
          idEvaluacion: idEvaluacion,
          input: {
            profesionalTipo: profesionales?.profesionalTipos,
            profesionalEspecialidad: profesionales?.profesionalEspecialidades
          }
        }
      });
      toast.success('Profesionales cargados con éxito');
    } catch (err) {
      toast.error('Ocurrió un error al cargar los profesionales');
    }
  };

  const handleChange = (name, value) => {
    setProfesionales((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  return (
    <Card sx={{ width: '100%', marginTop: '30px' }} elevation={0}>
      <CardContent>
        <div className='section-container-profesionales'>
          <div className='step-form-section-container' key={"TipoProfesional"}>
            <div>
              <label className={`step-form-section-title`}> Equipo de seguimiento </label>
              <Grid
                container>
                {tiposProfesionales &&
                  <RadioGroupInput
                    adicionalValues={profesionales.profesionalTipos}
                    inputName="profesionalTipos"
                    options={tiposProfesionales}
                    onChange={handleChange}
                    row={false} />

                }
              </Grid>
            </div>
          </div>

          {
            !moduloCP && <div className='step-form-section-container' key={"ProfesionalEspecialidad"}>
              <div>
                <label className={`step-form-section-title`}> Equipo de especialistas </label>
                <Grid
                  container>
                  {profesionalesEspecialidad &&
                    <RadioGroupInput
                      adicionalValues={profesionales.profesionalEspecialidades}
                      inputName="profesionalEspecialidades"
                      options={profesionalesEspecialidad}
                      onChange={handleChange}
                      row={false} />

                  }
                </Grid>
              </div>
            </div>
          }
          <CustomButton
            isLoading={profesionalesLoading}
            disabled={readOnly}
            className='margin-right'
            variant="outlined"
            onClick={() => onSubmit()}>

            Guardar Profesionales
          </CustomButton>
        </div>

      </CardContent>
    </Card>);

};

export default ProfesionalesInput;